<app-ace-select
  [formControl]="formControl"
  [items]="metadataUnits"
  [placeholder]="'Select Unit' | messageTranslate"
  [bindLabel]="'unit'"
  [multiSelect]="false"
  [appendTo]="appendTo"
  (touched)="onTouched()"/>
